export enum HTTP_REQUEST_METHODS {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  PATCH = 'PATCH',
  DELETE = 'DELETE',
  HEAD = 'HEAD'
}

export enum RESPONSE_FIELD {
  PARAMS = 'Params',
  AUTHORIZATION = 'Authorization',
  HEADERS = 'Headers',
  BODY = 'Body'
}

export enum AUTHORIZATION_AUTH_TYPES {
  NO_AUTH = 'No Auth',
  BASIC_AUTH = 'Basic Auth',
  BEARER_TOKEN = 'Bearer Token',
  JWT_BEARER = 'JWT Bearer'
}

export enum BODY_TYPES {
  FORM_DATA = 'form-data',
  FORM_URLENCODED = 'x-www-form-urlencoded',
  RAW_DATA = 'raw'
}

export enum JWT_TOKEN_ADD_TO {
  REQUEST_HEADERS = 'Request header',
  QUERY_PARAM = 'Query Param'
}

export enum BODY_RAW_TYPES {
  TEXT = 'Text',
  JAVASCRIPT = 'JavaScript',
  JSON = 'JSON',
  HTML = 'HTML',
  XML = 'XML'
}

export enum JWT_AVAILABLE_ALGORITHMS {
  HS256 = 'HS256',
  HS384 = 'HS384',
  HS512 = 'HS512'
}

export enum RequestSection {
  PARAMS = 'Params',
  AUTHORIZATION = 'Authorization',
  BODY = 'Body',
  HEADERS = 'Headers'
}

export const DISALLOWEDDOMAINS = ['https://www.jdoodle.com', window.location.origin]

export const DISALLOWEDPATTERNS = DISALLOWEDDOMAINS.map((domain) => new RegExp(`^${domain}/api/.*`))

export const CORS_ERROR =
  'Something went wrong. Please try enabling CORS for this endpoint and try again.'
